import { add } from 'date-fns';
import React, { useEffect, useState } from 'react';

import { MonthView } from './__month/week-picker__month';
import { YearView } from './__year/week-picker__year';

import './week-picker.scss';

export interface MarkedDay {
    day: Date;
    color: string;
}

interface Props {
    startDate: Date;
    endDate: Date;
    onChangeWeek: (startDate: Date, endDate: Date) => void;
    onChangeMonth?: (month: Date) => void;
    markedDays?: MarkedDay[];
    minDate?: Date;
    progress?: boolean;
}

enum CALENDAR_MODE {
    MONTH = 'month',
    YEAR = 'year',
}

export const WeekPicker = (props: Props) => {
    const { startDate, onChangeWeek, markedDays, minDate, onChangeMonth, progress } = props;
    // вычисляем месяц по количеству дней
    const [selectedMonth, selectMonth] = useState(add(startDate, { days: 3 }));
    const [calendarMode, setCalendarMode] = useState(CALENDAR_MODE.MONTH);

    useEffect(() => {
        if (onChangeMonth) {
            onChangeMonth(selectedMonth);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCurrentMonthClick = () => {
        setCalendarMode(CALENDAR_MODE.YEAR);
    };

    const handleSelectMonth = (month: Date) => {
        if (onChangeMonth) {
            onChangeMonth(month);
        }

        selectMonth(month);
        setCalendarMode(CALENDAR_MODE.MONTH);
    };

    return (
        <div className="week-picker">
            {calendarMode === CALENDAR_MODE.MONTH && (
                <MonthView
                    markedDays={markedDays}
                    minDate={minDate}
                    onChangeMonth={handleSelectMonth}
                    onChangeWeek={onChangeWeek}
                    onMonthClick={handleCurrentMonthClick}
                    progress={progress}
                    selectedMonth={selectedMonth}
                    selectedWeek={startDate}
                />
            )}
            {calendarMode === CALENDAR_MODE.YEAR && (
                <YearView minDate={minDate} onSelectMonth={handleSelectMonth} selectedMonth={selectedMonth} />
            )}
        </div>
    );
};
